import { render, staticRenderFns } from "./FormBill.vue?vue&type=template&id=2c23b52a&"
import script from "./FormBill.vue?vue&type=script&lang=ts&"
export * from "./FormBill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports